"use client";

import { FooterSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedFooterSection from "../Components/GeneratedFooterSection";

const Footer: FC<FooterSectionProps> = (props) => {
  return <GeneratedFooterSection {...props} />;
};

export default Footer;
